export const copyToClipboard = string => {
  const copyText = document.createElement('input');
  copyText.value = string;
  document.body.appendChild(copyText);
  copyText.select();

  document.execCommand('copy');

  document.body.removeChild(copyText);
};
